// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"edc2abe1","990":"a6df1f27"}[chunkId] + ".chunk.js";
};